import React from "react";
import { dateRange, initials } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function MonogramTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug p-7" data-testid="resume-live-preview">
      <div className="flex items-center gap-4 pb-4 border-b" style={{ borderColor: `${accent}30` }}>
        <div className="w-12 h-12 rounded-lg flex items-center justify-center text-white font-bold text-sm shrink-0" style={{ backgroundColor: accent }}>{initials(draft.full_name)}</div>
        <div>
          <h1 className="text-xl font-bold text-slate-900">{draft.full_name || "Your Name"}</h1>
          <p className="text-slate-500 text-[11px] mt-0.5">{[draft.target_role, draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" · ")}</p>
        </div>
      </div>

      {draft.summary && (
        <div className="mt-4 border rounded-lg p-3" style={{ borderColor: `${accent}25` }}>
          <h2 className="text-[11px] font-bold uppercase tracking-wider mb-1" style={{ color: accent }}>Summary</h2>
          <p className="text-slate-700">{draft.summary}</p>
        </div>
      )}
      {draft.skills.length > 0 && (
        <div className="mt-3 border rounded-lg p-3" style={{ borderColor: `${accent}25` }}>
          <h2 className="text-[11px] font-bold uppercase tracking-wider mb-1" style={{ color: accent }}>Skills</h2>
          <p className="text-slate-700">{draft.skills.join(" • ")}</p>
        </div>
      )}
      {draft.experience.length > 0 && (
        <div className="mt-3 border rounded-lg p-3" style={{ borderColor: `${accent}25` }}>
          <h2 className="text-[11px] font-bold uppercase tracking-wider mb-1.5" style={{ color: accent }}>Experience</h2>
          {draft.experience.map((e, i) => (
            <div key={i} className="mt-1.5">
              <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
              <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {draft.education.length > 0 && (
        <div className="mt-3 border rounded-lg p-3" style={{ borderColor: `${accent}25` }}>
          <h2 className="text-[11px] font-bold uppercase tracking-wider mb-1" style={{ color: accent }}>Education</h2>
          {draft.education.map((ed, i) => <p key={i} className="text-slate-700 mt-1"><span className="font-semibold text-slate-800">{ed.degree} {ed.field}</span> — {ed.school}</p>)}
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} variant="boxed" />
    </div>
  );
}
